import Vue from 'vue';
const eventBus = new Vue();
window.portalEventBus = eventBus;
export default eventBus;
